//
//
//
//
//
//
//
//
//

export default {
    props: ['span', 'float', 'height'],
    data () {
        return {

        }
    },
    computed: {
        mystyle: function() {
            return {
                "width": this.span + "%",
                "height": !!this.height ? this.height : 'auto',
                "float": !!this.float ? this.float : 'left'
            }
        },
        cellStyle: function() {
            return {
                "height": !!this.height ? this.height : 'auto',
            }
        }
    }
}
